import { render, staticRenderFns } from "./InformationAccountCard.vue?vue&type=template&id=0bd86f20&lang=pug"
import script from "./InformationAccountCard.vue?vue&type=script&lang=js"
export * from "./InformationAccountCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports